'use client';

import React, {FC} from 'react';
import Image from 'next/image';
import {useRouter} from 'next/navigation';

import {Button} from '@zoefin/design-system';

import {addToDataLayer} from '../../../../utils/pageUtils';

import styles from './styles.module.scss';

const Focus: FC = () => {
  const {push} = useRouter();

  const addToDataLayerHomePage = (section: string, label: string) => {
    addToDataLayer({
      overrideBase: 'Portal_Landing_Page',
      values: {
        Section: section,
        Label: label,
      },
    });
  };

  const redirectOnBoarding = (section: string, label: string) => {
    addToDataLayerHomePage(section, label);
    push('/onboarding');
  };

  return (
    <section className="section-focus">
      <div className={styles['focus']}>
        <div className="focus__banner">
          <picture>
            <source
              srcSet="/static/img/homepage/webp/focus-1.webp"
              type="image/webp"
            />
            <source
              srcSet="/static/img/homepage/focus-1.png"
              type="image/jpeg"
            />
            <Image
              src="/static/img/homepage/focus-1.png"
              alt="Focus on having the best life"
              className="w-100"
              width={1280}
              height={550}
            />
          </picture>
        </div>
        <div className={styles['focus__text']}>
          <div className={styles['focus__text_wrapper']}>
            <h3>
              Focus on enjoying your life, we&apos;ll worry about the rest.
            </h3>
            <div className="only-desktop only-desktop-btn">
              <Button
                button-testId="Button-desktop"
                onClick={() => redirectOnBoarding('Final Hero', 'Get Started')}
                style={{margin: '0 auto'}}
                as="button">
                Find An Advisor
              </Button>
            </div>
            <div className="only-mobile">
              <Button
                button-testId="Button-mobile"
                onClick={() => redirectOnBoarding('Final Hero', 'Get Started')}
                style={{margin: '0 auto'}}
                as="button">
                Find My Advisor
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Focus;
